<template>
  <div class="time-component">
    <v-btn icon @click="increase()" :color="color" small
      ><v-icon>arrow_drop_up</v-icon></v-btn
    >
    <input class="time a-text" v-model="value" />
    <v-btn icon @click="decrease()" :color="color" small
      ><v-icon>arrow_drop_down</v-icon></v-btn
    >
  </div>
</template>

<script>
export default {
  props: {
    type: { type: String, default: "hour" },
    initialValue: { type: Number, default: 0 },
    color: { type: String, default: "green lighten 1" },
  },
  data() {
    return {
      value: 0,
      max: 24,
    };
  },
  watch: {
    value() {
      if (this.value >= this.max) this.value = this.max - 1;
      if (!Number(this.value) && this.value != 0) this.value = "";
      this.$emit("input", this.value);
    },
  },
  created() {
    if (this.type === "minutes") this.max = 60;
    this.value = this.initialValue;
    this.$emit("input", this.value);
  },
  methods: {
    increase() {
      this.value++;
      if (this.value === this.max) this.value = 0;
    },
    decrease() {
      if (this.value === 0) this.value = this.max - 1;
      else this.value--;
    },
  },
};
</script>

<style scoped lang="scss">
.time-component {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50px;
}
.time {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 50px;
  width: 50px;
  border: 1px;
  border-style: solid ;
  border-color: $gray-light;
  border-radius: 5px;
}
</style>